import { ArrowRight, CheckCircle, LockKey, UserPlus } from '@phosphor-icons/react';
import { useState } from 'react';
import { api } from '../lib/api';
import type { User } from '../types';
import { Modal } from './Modal';

interface AuthModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (user: User) => void;
}

export function AuthModal({ open, onClose, onSuccess }: AuthModalProps) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setLoading(true);
    setError('');
    try {
      const credentials = {
        email: String(form.get('email')),
        password: String(form.get('password')),
      };
      const result = mode === 'login'
        ? await api.login(credentials)
        : await api.register({ ...credentials, name: String(form.get('name')) });
      onSuccess(result.user);
      onClose();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : '로그인하지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={mode === 'login' ? '작업을 이어서 하세요' : 'ExpoSpace 계정 만들기'} description="클라우드 저장과 공유는 로그인 후 사용할 수 있습니다." className="auth-modal">
      <div className="auth-visual" role="img" aria-label="전시 부스를 설계한 3D 공간 이미지" />
      <div className="auth-benefits">
        <span><CheckCircle size={17} /> 여러 기기에서 배치안 열기</span>
        <span><CheckCircle size={17} /> 공개 또는 지정 사용자 공유</span>
      </div>
      <form className="form-stack" onSubmit={handleSubmit}>
        {mode === 'register' && <label><span>이름</span><input name="name" required autoComplete="name" placeholder="김배치" /></label>}
        <label><span>이메일</span><input name="email" type="email" required autoComplete="email" placeholder="name@company.com" /></label>
        <label><span>비밀번호</span><input name="password" type="password" minLength={8} required autoComplete={mode === 'login' ? 'current-password' : 'new-password'} placeholder="8자 이상 입력" /></label>
        {error && <p className="form-error" role="alert">{error}</p>}
        <button className="button button-primary button-block" disabled={loading} type="submit">
          {mode === 'login' ? <LockKey size={17} /> : <UserPlus size={17} />}
          {loading ? '처리 중...' : mode === 'login' ? '로그인' : '계정 만들기'}
          {!loading && <ArrowRight size={17} />}
        </button>
      </form>
      <button className="auth-switch" type="button" onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }}>
        {mode === 'login' ? '계정이 없나요? 회원가입' : '이미 계정이 있나요? 로그인'}
      </button>
    </Modal>
  );
}
